import Immutable from 'immutable';

export type RFIImpactCategoryKind =
  | 'NONE'
  | 'COST'
  | 'SCHEDULE'
  | 'COST_AND_SCHEDULE';

export interface ImpactCategories {
  NONE: string;
  COST: string;
  SCHEDULE: string;
  COST_AND_SCHEDULE: string;
}

export const impactCategories: ImpactCategories = {
  NONE: 'None',
  COST: 'Cost',
  SCHEDULE: 'Schedule',
  COST_AND_SCHEDULE: 'Cost & Schedule',
};

export interface RawImpactCategory {
  kind: RFIImpactCategoryKind;
  display: string;
}

const defaultValues: RawImpactCategory = {
  kind: 'NONE',
  display: 'None',
};

export const ImpactCategoryFactory = Immutable.Record(
  defaultValues,
  'ImpactCategory'
);

export class ImpactCategory extends ImpactCategoryFactory {
  static deserialize(rawImpactCategory: RawImpactCategory): ImpactCategory {
    return new ImpactCategory({
      ...rawImpactCategory,
    });
  }

  serialize(): RawImpactCategory {
    return this.toObject();
  }
}
